<template>
  <div class="PatternPermission">
    <box :title="$t('Pattern.patternPermission') + PatternName">
      <div class="pa-2">
        <v-row>
          <v-col
            class="pa-0"
            cols="12"
            sm="6"
            v-for="(item, index) in permissionList"
            :key="index"
          >
            <v-checkbox
              multiple
              hide-details
              :value="item.permissionID"
              :label="item.permissionName"
              v-model="selectedPermissions"
              class="checkbox-rtl"
            />
          </v-col>
        </v-row>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="changePermission">{{
          $t("Pattern.changePermission")
        }}</v-btn>
      </v-card-actions>
    </box>
  </div>
</template>

<script>
import EosToastType from "../../../model/EosToastType";
import ResultType from "../../../model/ResultType";
export default {
  data() {
    return {
      args: null,
      PatternName: "",
      permissionList: [],
      selectedPermissions: [],
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      this.args = this.$route.query;
      this.PatternName = this.args.pname;
      this.loadPermission();
      this.GetPatternPermission();
    },
    GetPatternPermission() {
      var pid = this.args.pid;
      this.$store.dispatch("GetPatternPermission", { pid }).then((result) => {
        ////console.log(result);
        if (result.type === ResultType.success) {
          var strPermission = result.data;
          var permissions = Array.from(strPermission);
          //console.log(permissions);
          permissions.forEach((element, i) => {
            if (element == 1) {
              this.selectedPermissions.push(i);
            }
          });
        }
      });
    },
    loadPermission() {
      //chkPermission.DataSource = Permission.AdminPermissionList();
      this.$store.dispatch("GetAdminPermissionList").then((result) => {
        ////console.log(result);
        if (result.type === ResultType.success) {
          this.permissionList = result.data.Table;
        }
      });
    },
    changePermission() {
      var permissions = Array(100).fill(0);
      this.selectedPermissions.forEach((element) => {
        permissions[Number(element)] = 1;
      });

      var strPermission = permissions.join("");
      ////console.log(strPermission);

      var payload = {
        id: this.args.pid,
        permission: strPermission,
      };
      this.$store
        .dispatch("UpdatePatternPermission", { payload })
        .then((result) => {
          //console.log(result);

          if (result.type == ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });

            var query = {
              pid: this.args.pid,
              pname: this.args.pname,
            };
            this.$router.push({ name: "patternApproveCode", query: query });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("operationFailed"),
            });
          }
        });
    },
  },
};
</script>

<style>
</style>